import { Button, CircularProgress } from "@mui/material";
import { useContext, useState } from "react";
import { UserContext } from "../contexts/UserContext";
import axios from "axios";
import { prependUserToSelectNote } from "../utils/prependUserToSelectNote";
import { SearchNotOrdered } from "./types";
import { buildTempNote } from "./notes/buildTempNote";
import { useSearchesNotOrdered } from "./SearchesNotOrderedContext";
import { processSearchStatuses } from "./processSearchStatuses";

export function ActionNoteButton({ entity }: { entity: SearchNotOrdered }) {
  const { user } = useContext(UserContext);
  const { setSearchesNotOrdered, searchesNotOrdered } = useSearchesNotOrdered();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const save = async () => {
    setIsLoading(true);
    if (!user) return;
    let text = "";
    if (entity.actionKey === "Confirmed") {
      text = "ETA Confirmed";
    } else if (entity.actionKey === "Requested") {
      text = entity.eta ? "ETA Accuracy Requested" : "ETA Requested";
    }

    const noteTextWithUser = prependUserToSelectNote(text, user.name);

    await axios
      .post("/proxy/api/orders/AddNoteToRequestedTask", {
        orderNumber: entity.orderNumber,
        taskDescription: "County Search",
        text: noteTextWithUser
      })
      .catch(() => {
        setIsLoading(false);
      });

    var newNote = buildTempNote(noteTextWithUser, entity, user?.name!!);

    const updatedEntity = {
      ...entity,
      notes: [...entity.notes, newNote]
    };

    const updatedData = processSearchStatuses(
      searchesNotOrdered.map((s) => (s.orderNumberWithPrefix === entity.orderNumberWithPrefix ? updatedEntity : s))
    );

    setSearchesNotOrdered(updatedData);

    setIsLoading(false);
  };

  return (
    <Button
      variant="text"
      size="small"
      color="secondary"
      onClick={save}
      disabled={isLoading}
      endIcon={isLoading ? <CircularProgress size={16} /> : undefined}
    >
      {entity.actionKey}
    </Button>
  );
}
